module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('image-control', {
    attrs: {
      "image-id": _vm.form.image_id
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.image_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "image_id", $$v)
      },
      expression: "form.image_id"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "select",
      "id": "company",
      "label": "Show On Company Website</small>",
      "error": _vm.form.errors.get('company'),
      "option_name": 'name',
      "option_value": 'value',
      "options": [{
          name: 'All Companies',
          value: ''
        },
        {
          name: 'Crockett',
          value: 'CF'
        },
        {
          name: 'Bells',
          value: 'BELLS'
        } ]
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Slug",
      "id": "slug",
      "error": _vm.form.errors.get('slug')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.slug),
      callback: function($$v) {
        _vm.$set(_vm.form, "slug", $$v)
      },
      expression: "form.slug"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Name",
      "id": "name",
      "error": _vm.form.errors.get('name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "textarea",
      "label": "Description",
      "id": "description",
      "error": _vm.form.errors.get('description')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3d357a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/forms/BundleForm.vue
// module id = 583
// module chunks = 0